import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { OperationType } from 'relay-runtime';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type ProductsJcsStorageManagementEntryPointComponent = EntryPointComponent<
	Record<string, OperationType>,
	// oxlint-disable-next-line @typescript-eslint/no-explicit-any
	Record<string, EntryPoint<any, any> | undefined>,
	{},
	{}
>;

export const productsJcsStorageManagementEntryPoint: EntryPoint<
	ProductsJcsStorageManagementEntryPointComponent,
	{}
> = createEntryPoint({
	root: JSResourceForInteraction<ProductsJcsStorageManagementEntryPointComponent>(
		/* webpackChunkName: "async-products-jcs-storage-management", jiraSpaEntry: "async-products-jcs-storage-management" */ './ProductsJcsStorageManagement.tsx',
	),
	getPreloadProps: () => ({
		queries: {},
	}),
});
